import React from "react"


const MisuraTeletta = props => {
  const { lingua } = props

  return (
    
        <div>
          <div className="content">
            <p>{lingua.navigazione.misure.teletta1}</p>
            </div>
        </div>
      
  )
}

export default MisuraTeletta
